import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import logoMark from './logo-mark.svg'
import logoMarkMask from './logo-mark-mask.svg'
import logoWordmark from './logo-wordmark.svg'

// Kích thước gốc của component Logo/Border trong Figma (px)
const BASE_WIDTH = 40
const BASE_HEIGHT = 44

/** Logo/Border (Figma 8:9701): mark + wordmark BORDER, scale theo `width`. */
const BorderLogo = React.forwardRef(({ width = BASE_WIDTH, height, sx, ...props }, ref) => {
  const s = width / BASE_WIDTH
  const px = (value) => `${value * s}px`

  return (
    <Box
      ref={ref}
      role="img"
      aria-label="BORDER"
      sx={{ position: 'relative', flexShrink: 0, width: `${width}px`, height: `${height ?? BASE_HEIGHT * s}px`, ...sx }}
      {...props}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: px(10),
          py: px(1),
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: px(23.784),
            height: px(23.928),
            ml: px(0.04),
            mt: px(0.04),
            maskImage: `url("${logoMarkMask}")`,
            maskSize: `${px(23.856)} ${px(24)}`,
            maskPosition: `${px(-0.036)} ${px(-0.036)}`,
            maskRepeat: 'no-repeat',
            maskMode: 'alpha'
          }}
        >
          <Box sx={{ position: 'absolute', inset: '-0.15%' }}>
            <Box component="img" src={logoMark} alt="" sx={{ display: 'block', width: '100%', height: '100%' }} />
          </Box>
        </Box>
        <Box component="img" src={logoWordmark} alt="" sx={{ display: 'block', width: px(40), height: px(7.564) }} />
      </Box>
    </Box>
  )
})

BorderLogo.displayName = 'BorderLogo'

BorderLogo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  sx: PropTypes.object
}

export default BorderLogo
